<template>
    <a-dropdown :getPopupContainer="e => {return e.parentNode || document.body}">
        <div class="select-tank">
            <div class="tank-name">{{ currentAgentData && currentAgentData.agentName }}</div>
            <img :src="icon_down" alt="" srcset="" class="icon_img" />
        </div>

        <a-menu slot="overlay">
            <a-menu-item class="menu-item create-hover" @click="setTankClearFn">
                <img :src="newMenuIcon" alt="" class="menu-icon icon_no_hover" />
                <img :src="newMenuIconHover" alt="" class="menu-icon icon_hover" />
                <div class="menu-text">新建会话</div>
            </a-menu-item>
            <a-menu-item class="menu-item delete-hover" @click="setAgentCancelTop" v-if="currentAgentData && currentAgentData.agentTop == 0 ">
                <img :src="topIcon" alt="" class="menu-icon icon_no_hover" />
                <img :src="topIconHover" alt="" class="menu-icon icon_hover" />
                <div class="menu-text">取消置顶</div>
            </a-menu-item>
            <a-menu-item class="menu-item top-hover" @click="setAgentTop" v-if="currentAgentData && currentAgentData.agentTop == 1">
              <img :src="toTopIcon" alt="" class="menu-icon icon_no_hover" />
              <img :src="topImg" alt="" class="menu-icon icon_hover" />
              <div class="menu-text">置顶</div>
            </a-menu-item>
        </a-menu>

    </a-dropdown>
  
</template>

<script>
import icon_down from '@/assets/icon_down.png'
import newMenuIcon from '@/assets/new-menu-icon.png'
import topIcon from '@/assets/top-icon.png'
import toTopIcon from '@/assets/to-top-icon.png'
import topImg from '@/assets/top-img.png'
import topIconHover from '@/assets/top-icon-hover.png'
import newMenuIconHover from '@/assets/new-menu-icon-hover.png'
import { mapState,mapMutations,mapActions } from 'vuex'
import {agentCancelTop, agentTop} from '@/services/agent'
export default {
    computed: {
        ...mapState('agent', ['currentAgentData']),
    },
    data() {
        return {
            icon_down,
            newMenuIcon,
          toTopIcon,
          topImg,
            topIcon,
            topIconHover,
            newMenuIconHover,
        }
    },
    methods: {
        ...mapMutations('message',['setClear']),
        ...mapActions('agent',['getAgentList']),
        ...mapMutations('agent',['setCurrentAgent']),
        setTankClearFn(){
            if(this.$route.fullPath != '/tank'){
                this.$router.replace('/tank')
            }
            setTimeout(() => {
                this.setClear()
            }, 500)
        },
        async setAgentCancelTop(){
            let res = await agentCancelTop(this.currentAgentData.agentId)
            if(res.code == 200){
                this.$message.success(res.message)
              this.setCurrentAgent({
                ...this.currentAgentData,
                agentTop:1
              })
                this.getAgentList()
            }
        },
      async setAgentTop(){
        let res = await agentTop(this.currentAgentData.agentId)
        if(res.code == 200){
          this.$message.success(res.message)
          this.setCurrentAgent({
            ...this.currentAgentData,
            agentTop:0
          })
          this.getAgentList()
        }
      },
    }
}
</script>

<style lang="scss" scoped>
.select-tank{
    padding: 10px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    line-height: 20px;
}
.select-tank:hover{
    background: rgba(1,10,28,0.05);
}
.icon_img{
    width: 16px;
    height: 16px;
    margin-left: 8px;
}
.menu-item{
    display: flex;
    align-items: center;
    padding: 8px 16px;
    .menu-icon{
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
    .menu-text{
        font-size: 14px;
        color: #666666;
        line-height: 19px;
    }
}
.menu-item:hover{
    background: transparent;
}
.create-hover:hover{
    .icon_no_hover{
        display: none;
    }
    .icon_hover{
        display: inline-block;
    }
    .menu-text{
        color: $base_color;
    }
}
.delete-hover:hover{
    .menu-text{
        color: #FF3B30;
    }
    .icon_no_hover{
        display: none;
    }
    .icon_hover{
        display: inline-block;
    }
}
.top-hover:hover{
  .menu-text{
    color: $base_color;
  }
  .icon_no_hover{
    display: none;
  }
  .icon_hover{
    display: inline-block;
  }
}

.icon_hover{
    display: none;
}
.tank-name{
    max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
}
</style>